"use client"
import Script from "next/script"
import { useLazyThirdParty } from "@/hooks/useLazyThirdParty"

// Loads on every page so GHL form embeds render for all visitors — matches the site posture
// (booking widget / GA / Meta Pixel). Previously gated on getConsentPrefs()?.functional, but the
// CookieConsent banner that wrote that state is no longer rendered (consentmanager replaced it),
// so getConsentPrefs() was always null and forms were broken for UK/EEA visitors. form_embed.js is
// white-labelled from link.zip360.co.za; tagged data-cmp-ab="off" so the CMP does not strip it.
export function GHLFormScript({ nonce }: { nonce?: string }) {
  // Deferred to first interaction so form_embed.js does not set third-party cookies
  // on a page the visitor never touches. Any click/scroll/keypress loads it before a
  // visitor can reach a form.
  const interacted = useLazyThirdParty()
  if (!interacted) return null
  return (
    <Script
      src="https://link.zip360.co.za/js/form_embed.js"
      strategy="afterInteractive"
      nonce={nonce}
      data-cmp-ab="off"
    />
  )
}
